var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshSingleArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 26.6667C17.0152 26.6667 20.3486 25.1743 22.7614 22.7614L20.8758 20.8758C18.9455 22.8061 16.2789 24 13.3333 24C7.4423 24 2.66667 19.2244 2.66667 13.3333C2.66667 7.4423 7.4423 2.66667 13.3333 2.66667C16.9599 2.66667 20.1638 4.47653 22.091 7.24231L18.6667 10.6667H26.6667V2.66667L24.0006 5.33278C21.568 2.09457 17.6953 0 13.3333 0C5.96954 0 0 5.96954 0 13.3333C0 20.6971 5.96954 26.6667 13.3333 26.6667Z",
    fill: "#313131"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 26.6667C17.0152 26.6667 20.3486 25.1743 22.7614 22.7614L20.8758 20.8758C18.9455 22.8061 16.2789 24 13.3333 24C7.4423 24 2.66667 19.2244 2.66667 13.3333C2.66667 7.4423 7.4423 2.66667 13.3333 2.66667C16.9599 2.66667 20.1638 4.47653 22.091 7.24231L18.6667 10.6667H26.6667V2.66667L24.0006 5.33278C21.568 2.09457 17.6953 0 13.3333 0C5.96954 0 0 5.96954 0 13.3333C0 20.6971 5.96954 26.6667 13.3333 26.6667Z",
    fill: "#313131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshSingleArrow);
export default __webpack_public_path__ + "static/media/RefreshSingleArrow.ef243bd064b12b8ee7280cdf7593cc67.svg";
export { ForwardRef as ReactComponent };